import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import React from "react";

const ParentSubmitWarningDialog = ({ subClients, onClose, onConfirm }) => {
  const [isChecked, setIsChecked] = React.useState(false);

  return (
    <Dialog
      title={"Contribution Model Submission Warning"}
      onClose={onClose}
      width={500}
    >
      <div style={{ padding: "10px 0" }}>
        <p
          style={{ fontWeight: "bold", color: "#c0392b", marginBottom: "15px" }}
        >
          Attention: Action Required
        </p>
        <p style={{ fontSize: "14px", lineHeight: "1.5", color: "#333" }}>
          By submitting this contribution model, you are confirming that these
          definitions will be automatically locked and applied to <b>all </b>
          selected child companies.
        </p>

        <div
          style={{
            margin: "15px 0",
            padding: "10px",
            backgroundColor: "#f9f9f9",
            borderRadius: "4px",
            borderLeft: "4px solid #3498db",
            maxHeight: "120px",
            overflowY: "auto",
          }}
        >
          <span style={{ fontSize: "12px", fontWeight: "bold", color: "#666" }}>
            Affected Companies:
          </span>
          <ul style={{ margin: "5px 0 0 15px", padding: 0, fontSize: "13px" }}>
            {subClients.map((child) => (
              <li key={child.clientId} style={{ marginBottom: "2px" }}>
                <strong>{child.clientId}</strong> - {child.clientName}
              </li>
            ))}
          </ul>
        </div>

        <div
          style={{
            marginTop: "20px",
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          <input
            type="checkbox"
            id="chk-confirm-parent-submit"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            style={{ marginTop: "4px", cursor: "pointer" }}
          />
          <label
            htmlFor="chk-confirm-parent-submit"
            style={{
              fontSize: "13px",
              color: "#2c3e50",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            I acknowledge that this action will replicate and submit the
            contribution model for all child clients listed above.
          </label>
        </div>
      </div>

      <DialogActionsBar layout={"end"}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          themeColor={"primary"}
          onClick={onConfirm}
          disabled={!isChecked}
        >
          Proceed to Disclosure
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default ParentSubmitWarningDialog;
